import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('DocusignEnvelope')
export class DocusignEnvelope extends AbstractModel {

    @JsonProperty(DateConverter, 'createdDate')
    createdDate?: Date;

    @JsonProperty(String, 'envelopeId')
    envelopeId?: string;

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(DateConverter, 'sentDate')
    sentDate?: Date;

    @JsonProperty(DateConverter, 'signedDate')
    signedDate?: Date;

    @JsonProperty(String, 'status')
    status?: string;

}